import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { primitive } from 'styles/constants/primitives';

import { CONTAINER_SPACING_TOP, CONTAINER_SPACING_TOP_DESKTOP } from './constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: ${CONTAINER_SPACING_TOP};
  ${Styles.desktop`
    margin-top: ${CONTAINER_SPACING_TOP_DESKTOP};
    margin-bottom: ${primitive.$spacing7};
  `}
`;
export const Title = styled.h1`
  font: ${brandFont.headerOne};
  text-transform: capitalize;
  margin: 0;
`;
export const Text = styled.p`
  margin: 0;
  font: ${brandFont.copyOne};
  text-align: center;
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${primitive.$spacing4};
  width: 80%;
  ${Styles.desktop`
    width: 300px;
  `}
`;
export const ButtonLabel = styled.p`
  text-transform: capitalize;
  margin: 0;
`;
